import Box from "@material-ui/core/Box";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import React, { Fragment } from "react";
const LoadingPaper = () => (
    <Fragment>
        <Box p={3}>
            <Typography mb={3} variant={"h5"}>
                Загружаем данные...
            </Typography>
        </Box>
        <Box mt={4}>
            {" "}
            <LinearProgress mt={3} />{" "}
        </Box>
    </Fragment>
);

export default LoadingPaper;
